module.exports = __webpack_public_path__ + "static/media/V2MastheadWebsite.1db3579a.mp4";